let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hWjow")).then(() => parcelRequire('3x096'));